import React from 'react'
import styled from 'styled-components'

import { AvailableCategories } from '../scripts/AvailableCategories'

import CategoryInfoHeader from '../components/CategoryInfoHeader'
import SiteIcons from '../assets/SiteIcons'

const SubNav = (props) => {

  const NavChange = () => {
    props.navChange()
    props.navTypeChange('categories')
  }

  let category = props.category

  // get the category name
  let categoryName = 'All Library Courses'
  let categoryID

  const getCatName = () => {
    if ( category !== undefined && category !== 'all-courses' ) {
      AvailableCategories.map(cat => {
        if ( category === cat.url) {
          categoryName = cat.name
          categoryID = cat.id
        }
      })
    }
  }
  getCatName()

  const viewChange = (a) => {
    props.viewChange(a)
  }

  let gridView = ''
  let listView = ''

  if ( props.viewState === 'grid' ) {
    gridView = 'active'
    listView = ''
  } else {
    gridView = ''
    listView = 'active'
  }

  let mobileClass

  if ( props.mobile === true ) {
    mobileClass = 'mobile'
  } else {
    mobileClass = ''
  }

  let showSubNav

  if ( props.showSubNav === false ) {
    showSubNav = ''
  } else {
    showSubNav = ' show'
  }


  const SubNavStyled = styled.nav`
    color: ${props.themeStyles.subNavText};
    background-color: ${props.themeStyles.subNavBackground};
    border-bottom: solid 1px ${props.themeStyles.borderColor};
  `

  const CategoryLinkStyled = styled.div`
    border-right: solid 1px ${props.themeStyles.borderColor};
  `

  const CatLinkStyled = styled.div`

    .icon {
      #accent {
        stroke: ${props.themeStyles.subNavText};
      }

      #fill {
        fill: none;
      }

      #lines {
        stroke: ${props.themeStyles.subNavText};
      }
    }

    &:hover {
      color: ${props.themeStyles.mainColor};
      background-color: ${props.themeStyles.subNavBackgroundHover};

      .icon {
        #accent {
          stroke: ${props.themeStyles.subNavBackgroundHover};
        }

        #fill {
          fill: ${props.themeStyles.mainColor};
        }

        #lines {
          stroke: ${props.themeStyles.mainColor};
        }
      }
    }

  `

  const ViewButtonsContainer = styled.div`
    border-left: solid 1px ${props.themeStyles.borderColor};
  `

  const ViewButtons = styled.div`
    .icon {
      #fill {
        fill: ${props.themeStyles.subNavText};
      }
      #lines {
        stroke: ${props.themeStyles.subNavText};
      }
    }

    &.active {
      .icon {
        #fill {
          fill: ${props.themeStyles.subNavText};
        }

        #lines {
          stroke: ${props.themeStyles.subNavText};
        }
      }
    }

    &:hover {
      background-color: ${props.themeStyles.subNavBackgroundHover};

      .icon {
        #fill {
          fill: ${props.themeStyles.mainColor};
        }
        #lines {
          stroke: ${props.themeStyles.mainColor};
        }
      }
    }
  `


  return (

    <SubNavStyled id="subNav" className={mobileClass + showSubNav}>
      <CategoryLinkStyled className="categoryLink">
        <CatLinkStyled id="catLink" onClick={NavChange}>
          <SiteIcons icon="categories" />
          {props.mobile === false &&
            <span>Categories</span>
          }
        </CatLinkStyled>
      </CategoryLinkStyled>

      <CategoryInfoHeader categoryIcon={categoryID} categoryName={categoryName} mobile={props.mobile} themeStyles={props.themeStyles}  />

      {props.mobile === false &&
        <ViewButtonsContainer className="viewButtons">
          <div className="viewText"><span>View</span></div>
          <ViewButtons id="gridLink" className={gridView} onClick={() => viewChange('grid')}><SiteIcons icon="grid" /></ViewButtons>
          <ViewButtons id="listLink" className={listView} onClick={() => viewChange('list')}><SiteIcons icon="list" /></ViewButtons>
        </ViewButtonsContainer>
      }

    </SubNavStyled>


  )

}

export default SubNav
